import script from "./AccessibilityWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessibilityWidget.vue?vue&type=script&setup=true&lang=js"

import "./AccessibilityWidget.vue?vue&type=style&index=0&id=2bb25838&lang=scss"

const __exports__ = script;

export default __exports__